/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';
import { ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse } from '../model/modulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse';
import { ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse } from '../model/modulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse';
import { ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse } from '../model/modulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse';
import { ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse } from '../model/modulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse';
import { ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse } from '../model/modulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse';
import { ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse } from '../model/modulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse';
import { ModulesPlayoffsApplicationPlayoffsPlayoffResponse } from '../model/modulesPlayoffsApplicationPlayoffsPlayoffResponse';
import { ModulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel';
import { ModulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest } from '../model/modulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest';
import { ModulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel } from '../model/modulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { PlayoffsServiceInterface }                            from './playoffs.serviceInterface';


@Injectable()
export class PlayoffsService implements PlayoffsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets a Playoff.
     * Gets a Playoff using the Playoff identifier.
     * @param playoffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffByIdEndpoint(playoffId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>;
    public getPlayoffByIdEndpoint(playoffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>;
    public getPlayoffByIdEndpoint(playoffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>;
    public getPlayoffByIdEndpoint(playoffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayoffCourse.
     * Gets a PlayoffCourse using the Playoff and PlayoffCourse identifiers.
     * @param playoffId 
     * @param playoffCourseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffCourseByIdEndpoint(playoffId: string, playoffCourseId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>;
    public getPlayoffCourseByIdEndpoint(playoffId: string, playoffCourseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>;
    public getPlayoffCourseByIdEndpoint(playoffId: string, playoffCourseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>;
    public getPlayoffCourseByIdEndpoint(playoffId: string, playoffCourseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffCourseByIdEndpoint.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling getPlayoffCourseByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PlayoffCourses.
     * Gets all PlayoffCourses.
     * @param playoffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffCoursesEndpoint(playoffId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>;
    public getPlayoffCoursesEndpoint(playoffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>>;
    public getPlayoffCoursesEndpoint(playoffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>>;
    public getPlayoffCoursesEndpoint(playoffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffCoursesEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffCoursesPlayoffCourseResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a Playoff detail graph.
     * Gets the Playoff along with course, holes, players, scorecards, and scores using the Playoff identifier.
     * @param playoffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffDetailEndpoint(playoffId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse>;
    public getPlayoffDetailEndpoint(playoffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse>>;
    public getPlayoffDetailEndpoint(playoffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse>>;
    public getPlayoffDetailEndpoint(playoffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffDetailEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffsGetPlayoffDetailPlayoffDetailResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/detail`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayoffHole.
     * Gets a PlayoffHole using the Playoff, PlayoffCourse and PlayoffHole identifiers.
     * @param playoffId 
     * @param playoffCourseId 
     * @param playoffHoleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffHoleByIdEndpoint(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>;
    public getPlayoffHoleByIdEndpoint(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>;
    public getPlayoffHoleByIdEndpoint(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>;
    public getPlayoffHoleByIdEndpoint(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffHoleByIdEndpoint.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling getPlayoffHoleByIdEndpoint.');
        }

        if (playoffHoleId === null || playoffHoleId === undefined) {
            throw new Error('Required parameter playoffHoleId was null or undefined when calling getPlayoffHoleByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}/holes/${encodeURIComponent(String(playoffHoleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets PlayoffHoles for a PlayoffCourse.
     * Gets PlayoffHoles for a PlayoffCourse.
     * @param playoffId 
     * @param playoffCourseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffHolesEndpoint(playoffId: string, playoffCourseId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>;
    public getPlayoffHolesEndpoint(playoffId: string, playoffCourseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>>;
    public getPlayoffHolesEndpoint(playoffId: string, playoffCourseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>>;
    public getPlayoffHolesEndpoint(playoffId: string, playoffCourseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffHolesEndpoint.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling getPlayoffHolesEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffHolesPlayoffHoleResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}/holes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayoffPlayer.
     * Gets a PlayoffPlayer using the Playoff and PlayoffPlayer identifiers.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffPlayerByIdEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>;
    public getPlayoffPlayerByIdEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>;
    public getPlayoffPlayerByIdEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>;
    public getPlayoffPlayerByIdEndpoint(playoffId: string, playoffPlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffPlayerByIdEndpoint.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling getPlayoffPlayerByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all PlayoffPlayers.
     * Gets all PlayoffPlayers.
     * @param playoffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffPlayersEndpoint(playoffId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>;
    public getPlayoffPlayersEndpoint(playoffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>>;
    public getPlayoffPlayersEndpoint(playoffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>>;
    public getPlayoffPlayersEndpoint(playoffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffPlayersEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffPlayersPlayoffPlayerResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayoffScore.
     * Gets a PlayoffScore by its identifier.
     * @param playoffScoreId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffScoreByIdEndpoint(playoffScoreId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>;
    public getPlayoffScoreByIdEndpoint(playoffScoreId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoreByIdEndpoint(playoffScoreId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoreByIdEndpoint(playoffScoreId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffScoreId === null || playoffScoreId === undefined) {
            throw new Error('Required parameter playoffScoreId was null or undefined when calling getPlayoffScoreByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>('get',`${this.basePath}/playoffs/scores/${encodeURIComponent(String(playoffScoreId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a PlayoffScorecard.
     * Gets a PlayoffScorecard using the Playoff, PlayoffPlayer and PlayoffScorecard identifiers.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffScorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffScorecardByIdEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>;
    public getPlayoffScorecardByIdEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>;
    public getPlayoffScorecardByIdEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>;
    public getPlayoffScorecardByIdEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffScorecardByIdEndpoint.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling getPlayoffScorecardByIdEndpoint.');
        }

        if (playoffScorecardId === null || playoffScorecardId === undefined) {
            throw new Error('Required parameter playoffScorecardId was null or undefined when calling getPlayoffScorecardByIdEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards/${encodeURIComponent(String(playoffScorecardId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets PlayoffScorecards for a PlayoffPlayer.
     * Gets PlayoffScorecards for a PlayoffPlayer.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffScorecardsEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>;
    public getPlayoffScorecardsEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>>;
    public getPlayoffScorecardsEndpoint(playoffId: string, playoffPlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>>;
    public getPlayoffScorecardsEndpoint(playoffId: string, playoffPlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffScorecardsEndpoint.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling getPlayoffScorecardsEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffScorecardsPlayoffScorecardResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets PlayoffScores for a PlayoffHole.
     * Gets PlayoffScores for a PlayoffHole.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffHoleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffScoresByHoleEndpoint(playoffId: string, playoffPlayerId: string, playoffHoleId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>;
    public getPlayoffScoresByHoleEndpoint(playoffId: string, playoffPlayerId: string, playoffHoleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoresByHoleEndpoint(playoffId: string, playoffPlayerId: string, playoffHoleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoresByHoleEndpoint(playoffId: string, playoffPlayerId: string, playoffHoleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffScoresByHoleEndpoint.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling getPlayoffScoresByHoleEndpoint.');
        }

        if (playoffHoleId === null || playoffHoleId === undefined) {
            throw new Error('Required parameter playoffHoleId was null or undefined when calling getPlayoffScoresByHoleEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/holes/${encodeURIComponent(String(playoffHoleId))}/scores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets PlayoffScores for a PlayoffScorecard.
     * Gets PlayoffScores for a PlayoffScorecard.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffScorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffScoresByScorecardEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>;
    public getPlayoffScoresByScorecardEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoresByScorecardEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>>;
    public getPlayoffScoresByScorecardEndpoint(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling getPlayoffScoresByScorecardEndpoint.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling getPlayoffScoresByScorecardEndpoint.');
        }

        if (playoffScorecardId === null || playoffScorecardId === undefined) {
            throw new Error('Required parameter playoffScorecardId was null or undefined when calling getPlayoffScoresByScorecardEndpoint.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffScoresPlayoffScoreResponse>>('get',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards/${encodeURIComponent(String(playoffScorecardId))}/scores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets all Playoffs.
     * Gets all Playoffs.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayoffsEndpoint(observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>;
    public getPlayoffsEndpoint(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>>;
    public getPlayoffsEndpoint(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>>;
    public getPlayoffsEndpoint(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesPlayoffsApplicationPlayoffsPlayoffResponse>>('get',`${this.basePath}/playoffs`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PlayoffCourse.
     * Removes a PlayoffCourse using the PlayoffCourse identifier.
     * @param playoffId 
     * @param playoffCourseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPlayoffCourseIdDelete(playoffId: string, playoffCourseId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdDelete(playoffId: string, playoffCourseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdDelete(playoffId: string, playoffCourseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdDelete(playoffId: string, playoffCourseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdDelete.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PlayoffHole.
     * Removes a PlayoffHole using the PlayoffHole identifier.
     * @param playoffId 
     * @param playoffCourseId 
     * @param playoffHoleId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete(playoffId: string, playoffCourseId: string, playoffHoleId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete.');
        }

        if (playoffHoleId === null || playoffHoleId === undefined) {
            throw new Error('Required parameter playoffHoleId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}/holes/${encodeURIComponent(String(playoffHoleId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PlayoffHole.
     * Updates a PlayoffHole based on the Playoff, PlayoffCourse and PlayoffHole idenfiers and UpdatePlayoffHoleRequest.
     * @param playoffId 
     * @param playoffCourseId 
     * @param playoffHoleId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut(playoffId: string, playoffCourseId: string, playoffHoleId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut(playoffId: string, playoffCourseId: string, playoffHoleId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut(playoffId: string, playoffCourseId: string, playoffHoleId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut(playoffId: string, playoffCourseId: string, playoffHoleId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesUpdatePlayoffHoleRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut.');
        }

        if (playoffHoleId === null || playoffHoleId === undefined) {
            throw new Error('Required parameter playoffHoleId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPlayoffHoleIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}/holes/${encodeURIComponent(String(playoffHoleId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayoffHole.
     * Creates a PlayoffHole based on the PlayoffCourse identifier and the CreatePlayoffHoleRequest.
     * @param playoffId 
     * @param playoffCourseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffHolesCreatePlayoffHoleRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdHolesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}/holes`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PlayoffCourse.
     * Updates a PlayoffCourse based on the Playoff and PlayoffCourse idenfiers and UpdatePlayoffRequest.
     * @param playoffId 
     * @param playoffCourseId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPlayoffCourseIdPut(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdPut(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdPut(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdCoursesPlayoffCourseIdPut(playoffId: string, playoffCourseId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesUpdatePlayoffRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdPut.');
        }

        if (playoffCourseId === null || playoffCourseId === undefined) {
            throw new Error('Required parameter playoffCourseId was null or undefined when calling playoffsPlayoffIdCoursesPlayoffCourseIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses/${encodeURIComponent(String(playoffCourseId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayoffCourse.
     * Creates a PlayoffCourse based on the Playoff identifier and the CreatePlayoffCourseRequest.
     * @param playoffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdCoursesPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playoffsPlayoffIdCoursesPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playoffsPlayoffIdCoursesPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playoffsPlayoffIdCoursesPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffCoursesCreatePlayoffCourseRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdCoursesPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/courses`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a Playoff.
     * Removes a Playoff using the Playoff identifier.
     * @param playoffId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdDelete(playoffId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdDelete(playoffId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdDelete(playoffId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdDelete(playoffId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PlayoffPlayer.
     * Removes a PlayoffPlayer using the PlayoffPlayer identifier.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdDelete(playoffId: string, playoffPlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdDelete(playoffId: string, playoffPlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdDelete(playoffId: string, playoffPlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdDelete(playoffId: string, playoffPlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdDelete.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PlayoffPlayer.
     * Updates a PlayoffPlayer based on the Playoff and PlayoffPlayer idenfiers and UpdatePlayoffPlayerRequest.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdPut(playoffId: string, playoffPlayerId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdPut(playoffId: string, playoffPlayerId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdPut(playoffId: string, playoffPlayerId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdPut(playoffId: string, playoffPlayerId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersUpdatePlayoffRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdPut.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Removes a PlayoffScorecard.
     * Removes a PlayoffScorecard using the PlayoffScorecard identifier.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffScorecardId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete.');
        }

        if (playoffScorecardId === null || playoffScorecardId === undefined) {
            throw new Error('Required parameter playoffScorecardId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards/${encodeURIComponent(String(playoffScorecardId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a PlayoffScore.
     * Updates a PlayoffScore based on the PlayoffScore identifier and UpdatePlayoffScoreRequest.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffScorecardId 
     * @param playoffScoreId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, playoffScoreId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, playoffScoreId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, playoffScoreId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, playoffScoreId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresUpdatePlayoffScoreRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut.');
        }

        if (playoffScorecardId === null || playoffScorecardId === undefined) {
            throw new Error('Required parameter playoffScorecardId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut.');
        }

        if (playoffScoreId === null || playoffScoreId === undefined) {
            throw new Error('Required parameter playoffScoreId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPlayoffScoreIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards/${encodeURIComponent(String(playoffScorecardId))}/scores/${encodeURIComponent(String(playoffScoreId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayoffScore for a PlayoffPlayer.
     * Creates a PlayoffScore based on the PlayoffPlayer and PlayoffScorecard identifiers and the CreatePlayoffScoreForPlayerRequest.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param playoffScorecardId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost(playoffId: string, playoffPlayerId: string, playoffScorecardId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffScoresCreatePlayoffScoreForPlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost.');
        }

        if (playoffScorecardId === null || playoffScorecardId === undefined) {
            throw new Error('Required parameter playoffScorecardId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPlayoffScorecardIdScoresPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards/${encodeURIComponent(String(playoffScorecardId))}/scores`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayoffScorecard.
     * Creates a PlayoffScorecard based on the PlayoffPlayer identifier and the CreatePlayoffScorecardRequest.
     * @param playoffId 
     * @param playoffPlayerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost(playoffId: string, playoffPlayerId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost(playoffId: string, playoffPlayerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost(playoffId: string, playoffPlayerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost(playoffId: string, playoffPlayerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost.');
        }

        if (playoffPlayerId === null || playoffPlayerId === undefined) {
            throw new Error('Required parameter playoffPlayerId was null or undefined when calling playoffsPlayoffIdPlayersPlayoffPlayerIdScorecardsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('post',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players/${encodeURIComponent(String(playoffPlayerId))}/scorecards`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a PlayoffPlayer.
     * Creates a PlayoffPlayer based on the Playoff identifier and the CreatePlayoffPlayerRequest.
     * @param playoffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPlayersPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playoffsPlayoffIdPlayersPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playoffsPlayoffIdPlayersPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playoffsPlayoffIdPlayersPost(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffPlayersCreatePlayoffPlayerRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPlayersPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}/players`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates a Playoff.
     * Updates a Playoff based on the Playoff idenfier and UpdatePlayoffRequest.
     * @param playoffId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPlayoffIdPut(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public playoffsPlayoffIdPut(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public playoffsPlayoffIdPut(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public playoffsPlayoffIdPut(playoffId: string, body?: ModulesPlayoffsEndpointsContractsPlayoffsUpdatePlayoffRequestModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (playoffId === null || playoffId === undefined) {
            throw new Error('Required parameter playoffId was null or undefined when calling playoffsPlayoffIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/playoffs/${encodeURIComponent(String(playoffId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a Playoff.
     * Creates a Playoff based on the CreatePlayoffRequest request.
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public playoffsPost(body?: ModulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public playoffsPost(body?: ModulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public playoffsPost(body?: ModulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public playoffsPost(body?: ModulesPlayoffsEndpointsContractsPlayoffsCreatePlayoffRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/playoffs`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
